import { getStore } from './../store';
import { analyticsIsLoaded } from '../utils/ltAnalyticsService';

const piiFields = [
  'EmailAddress',
  'PhoneNumber',
  'FirstName',
  'LastName',
  'City',
  'State',
  'ZipCode',
  'Country',
];

const sanitizePIIData = async (formData) => {
  const output = {};
  const promises = Object.keys(formData)
    .filter(key => piiFields.includes(key))
    .map(async key => {
      output[key] = await generateSHA256Hash(formData[key]);
    });
  await Promise.all(promises);
  return output;
};

const generateSHA256Hash = async (value) => {
  try {
    const hashedValue = await ltanalytics.sha256(value);
    return hashedValue;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error during SHA256 hashing:', error);
    return null;
  }
};

export const buildHashedPII = async () => {
  const { formData } = getStore().getState();
  if (analyticsIsLoaded()) {
    try {
      return await sanitizePIIData(formData);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error in buildHashedPII:', error);
      return null;
    }
  } else {
    // eslint-disable-next-line no-console
    console.log('Analytics is not loaded');
    return null;
  }
};
